// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Eq0M","bigColWidth":"Table_bigColWidth__Ukmj1","biggerColWidth":"Table_biggerColWidth__3nCED","row":"Table_row__7msEZ","col":"Table_col__3944m"};